import { DefaultSheet, Row, SheetBody, Col, Button } from 'twyne-new.ui';

import Label from '@Components/pure/rules/Label';

import { DetailsModalItem } from './DetailsModal';

function NoContent() {
  return <Col className='flex justify-center items-center py-4'>
    <Label>No content to show.</Label>
  </Col>
}
const DefaultButton = ({ labelButton }) => <Button variant='light' color='accent'>
  {labelButton}
</Button>

export default function ObjectModal({ children, data, title, labelButton, button: OpenButton = DefaultButton }) {
  return <>
    <DefaultSheet
      title={title}
      trigger={<OpenButton labelButton={labelButton} />}
    >
      <SheetBody>
        <Row>
          {data ? data.length === 0 ? <NoContent /> : data?.map(([key, value], index) => <DetailsModalItem key={index} label={key} value={<Value label={key} value={value} />} />) : children}
        </Row>
      </SheetBody>
    </DefaultSheet>
  </>
}

export const Value = ({ label, value }) => {
  if (typeof value === 'string' && value.length > 50) {
    return <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{value}</pre>
  }

  if (typeof value === 'object' && value !== null) {
    return <pre style={{ maxHeight: 180, whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowY: 'auto' }}>{JSON.stringify(value || {}, null, 2)}</pre>
  }

  if (typeof value === 'boolean' && value !== null) {
    return { true: 'true', false: 'false' }[value]
  }

  if (label === "path_user_profile_id") {
    return value === null ? 'Default' : value
  }

  if (label === "slot_position") {
    return value + 1
  }

  if (typeof value === 'number') {
    return value
  }

  return <div className='text-sm'>{value}</div> || '--'
}
